import { render, staticRenderFns } from "./UpdateSitePage.vue?vue&type=template&id=35918449&scoped=true"
import script from "./UpdateSitePage.vue?vue&type=script&lang=js"
export * from "./UpdateSitePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35918449",
  null
  
)

export default component.exports